import React, { useEffect, useState } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import _ from 'lodash';
import { themes } from '../../../themes/themes';
import moment from 'moment';
import { useAppSelector } from '../../../../infra/hooks';
import Loader from '../../../Lottifiers/Loader/Loader';
import './LeaveStyle.css';
import { Box } from '@mui/material';
import ar from 'date-fns/locale/ar-SA';
import { useTranslate } from '../../../../hooks';

const LeaveCalendarDataPresenter = (prop) => {
  const [range, setRange] = useState([]);
  const isLoading = useAppSelector(
    (state) => state.leaveCalendarSlice.leaveCalendarLoader,
  );
  const leave_data = useAppSelector(
    (state) => state.leaveCalendarSlice.leaveCalendar,
  );

  useEffect(() => {
    const finalData = [];
    if (leave_data && leave_data.length) {
      _.map(leave_data, (d) => {
        const _formatStartDate = d?.start_date.split('T');
        const _formatEndDate = d?.end_date.split('T');

        const _startDate = moment(_formatStartDate[0]).format('YYYY-MM-DD');
        const _endDate = moment(_formatEndDate[0]).format('YYYY-MM-DD');

        let leave = {
          startDate: new Date(_startDate),
          endDate: new Date(_endDate),
          key: 'selection',
          color: themes.leaveCalender,
        };
        finalData.push(leave);
      });
      setRange(finalData);
    }
  }, [leave_data]);

  const handleChange = (_date) => {
    const getMonth = moment(_date).get('month');
    const getYear = moment(_date).get('year');
    prop.handleCalendarChange(getMonth, getYear);
  };

  const { isRTL } = useTranslate();

  return isLoading ? (
    <div style={{ width: '425px' }}>
      <Loader height={100} width={200} />
    </div>
  ) : (
    <div>
      <Box
        style={{
          overflowX: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <DateRange
          ranges={range}
          direction="horizontal"
          showDateDisplay={false}
          locale={isRTL ? ar : undefined}
          editableDateInputs={false}
          showPreview={false}
          className="leave__calendar__data"
          onShownDateChange={(DateRange) => handleChange(DateRange)}
          onChange={() => console.log('')}
          style={{
            width: '100%',
          }}
        />
      </Box>
    </div>
  );
};

export default LeaveCalendarDataPresenter;
